import React, { Component } from 'react';
import { withTheme } from 'styled-components';
import { Text, Link } from '@movember/mo-gel';
import { PropTypes } from 'prop-types';

import { StickyMenuItem } from './StickyMenuItem/StickyMenuItem';
import { StyledInfoWrapper, StyledStickyMenu } from './StickyMenu.styled';
import { ReactComponent as InfoIcon } from '../../images/icons/icon_info.svg';
import { ReactComponent as EditIcon } from '../../images/icons/icon_edit.svg';

const baseUrl = process.env.REACT_APP_BASE_URL;
const lapcdUrl = '/en-gb/life-after-prostate-cancer-diagnosis/';

class StickyMenu extends Component {
  constructor(props) {
    super(props);

    this.state = {
      selectedMenu: null
    };
  }

  onOpen = (index) => {
    const { onOpen } = this.props;
    if (onOpen) {
      this.setState({ selectedMenu: index });
      onOpen();
    }
  };

  onClose = () => {
    const { onClose } = this.props;
    if (onClose) {
      this.setState({ selectedMenu: null });
      onClose();
    }
  };

  renderInfoContent = () => {
    return (
      <StyledInfoWrapper>
        <Text>
          All of the results on this page come from the LAPCD study. 35,823 men participated in the study, 18 to 42
          months after prostate cancer treatment.
        </Text>
        <Text marginTop="20px" marginBottom="20px">
          Thanks to these incredible men, other men can now use this tool to better navigate their own prostate cancer
          journey.
        </Text>
        <Link href={`${baseUrl}${lapcdUrl}`}>More info about LAPCD</Link>
      </StyledInfoWrapper>
    );
  };

  render() {
    const { selectedMenu } = this.state;
    const { onEdit } = this.props;

    const menuItems = [
      {
        icon: InfoIcon,
        content: this.renderInfoContent(),
        onClick: (index) => this.onOpen(index),
        closeIconVisible: true,
        shortText: 'About results',
        text: 'About these results'
      },
      {
        icon: EditIcon,
        onClick: () => onEdit(),
        shortText: 'Edit selections',
        text: 'Edit your selections'
      }
    ];
    return (
      <StyledStickyMenu>
        {menuItems.map((menuItem, index) => {
          const menuDisabled = selectedMenu !== null && selectedMenu !== index;
          return (
            <StickyMenuItem
              key={`submenu-${index}`}
              icon={menuItem.icon}
              menuDisabled={menuDisabled}
              onClick={() => menuItem.onClick(index)}
              onClose={this.onClose}
              text={menuItem.text}
              shortText={menuItem.shortText}
              closeIconVisible={menuItem.closeIconVisible}
            >
              {menuItem.content}
            </StickyMenuItem>
          );
        })}
      </StyledStickyMenu>
    );
  }
}

const StickyMenuWrapper = withTheme(StickyMenu);
export { StickyMenuWrapper as StickyMenu };

StickyMenu.defaultProps = {
  onOpen: null,
  onEdit: null,
  onClose: null
};

StickyMenu.propTypes = {
  onOpen: PropTypes.func,
  onEdit: PropTypes.func,
  onClose: PropTypes.func
};
